import axios from 'axios';
import API_ENDPOINTS from '../../../apiEndpoints';
import { showWarningSnackbar } from '../../../components/snackBar/snakbar';
import type { AccountCheckResult } from '../types';

export async function checkAccountVerified(email: string): Promise<AccountCheckResult> {
  try {
    const response = await axios.post(API_ENDPOINTS.REACT_APP_SIGNUP_CHECK, { email });

    if (response.data.error === 'You Have Already Registered With Google Account. Use Google Sign In') {
      showWarningSnackbar('You Have Already Registered With Google Account. Use Google Sign In');
      return { userExists: true, isUnconfirmed: false, isGoogleAccount: true };
    }

    if (response.data.error === 'User Does not exist !') {
      return { userExists: false, isUnconfirmed: false, isGoogleAccount: false };
    }

    if (response.data.userStatus === 'UNCONFIRMED') {
      return { userExists: true, isUnconfirmed: true, isGoogleAccount: false };
    }

    return { userExists: true, isUnconfirmed: false, isGoogleAccount: false };
  } catch {
    return { userExists: false, isUnconfirmed: false, isGoogleAccount: false };
  }
}
